module.exports = __webpack_public_path__ + "img/Speaker=Ramona Pringle.6ab7c05f.png";